// @flow
import React from "react";
import _ from "lodash";
import styles from "./ToggleButton.scss";

const ToggleButton = props => {
  const { toggleBtn, toggleItems, selected, fullWidth, tab, btns } = props;
  const mainClass = tab ? "" : styles.toggleWrapper;
  const innerClass = tab ? styles.tabWrapper : styles.toggleInner;
  const eachTitle = tab ? styles.tabtitle : styles.eachToggle;
  const toggleContent =
    toggleItems && !_.isEmpty(toggleItems)
      ? toggleItems.map((item, index) => (
          <div key={index}
            className={`${
              selected === index + 1 ? styles.selected : ""
            } ${eachTitle}`}
            onClick={() => toggleBtn(index + 1)}
          >
            {item}
          </div>
        ))
      : "";

  return (
    <div className={mainClass}>
      <div className={`${innerClass} ${fullWidth ? styles.fullWidth : ""}`}>
        {toggleContent}
        {btns ? <div className={styles.btnIfCtr}>{btns}</div> : ""}
      </div>
    </div>
  );
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/components/common/toggleButton/ToggleButton.js